import { Inject, Injectable } from '@angular/core';
import { CRMApiService, CrmObjectSearch, ListCrmObjectsRequest } from '@vendasta/crm';
import { Observable, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { ACCOUNT_GROUP_TOKEN } from '../../tokens';
import { AccountGroup } from '../account-group';

@Injectable({
  providedIn: 'root',
})
export class CrmService {
  public contactIds$: Observable<string[]>;

  constructor(
    @Inject(ACCOUNT_GROUP_TOKEN) private readonly accountGroup$: Observable<AccountGroup>,
    private readonly crmService: CRMApiService,
  ) {
    this.contactIds$ = accountGroup$.pipe(
      switchMap((accountGroup) => {
        return this.crmService.listContacts({
          namespace: accountGroup.accountGroupId,
          search: { searchTerm: '' } as CrmObjectSearch,
          pagingOptions: {
            pageSize: 20,
          },
        } as ListCrmObjectsRequest);
      }),
      map((resp) => resp?.crmObjects?.map((contact) => contact.crmObjectId)),
    );
  }
}
